export default __webpack_public_path__ + "static/media/SmelterMk1.256.bde60e04.png";